module.exports = __webpack_public_path__ + "img/ic_education_history.757cb4e1.svg";